import {
  ref, reactive, readonly, Ref,
} from 'vue';

export default abstract class AbstractStore<T extends Object> {
  protected state: T;

  protected initialized !: Ref<boolean>;

  private _loading !: Ref<boolean>;

  constructor() {
    this._loading = ref(false);
    this.initialized = ref(false);
    this.state = reactive(this.data()) as T;
    this.initialize();
  }

  protected abstract data(): T

  protected abstract initialize(): void;

  public getState(): T {
    return readonly(this.state) as T;
  }

  public get isInitialized(): boolean {
    return this.initialized.value;
  }

  public setInitialized(value: boolean): void {
    this.initialized.value = value;
  }

  public get isLoading(): boolean {
    return this._loading.value;
  }

  protected get loading(): boolean {
    return this.isLoading;
  }

  protected set loading(loading: boolean) {
    this._loading.value = loading;
  }
}
